export default {
    agentList: {
        title: "Lista de Agentes",
        serial: "No.",
        agentIdCol: "ID del Agente",
        type: "Tipo de Agente",
        tag: "Etiqueta del Agente",
        typeRequired: "Seleccione el tipo de agente",
        // Diccionario de tipos de agente (dict_group_item grupo 51001): solo los tres
        // tipos predefinidos por el sistema se traducen; los tipos creados por el
        // operador conservan su texto almacenado mediante defaultValue
        typeDict: {
            "51001001": "Promoción en tienda física",
            "51001002": "Promoción publicitaria",
            "51001003": "Promoción regular",
        },
        name: "Nombre del Agente",
        nameRequired: "Ingrese el nombre del agente",
        agentCostStats:'Costo de Promoción',
        account: "Cuenta del Agente",
        accountRequired: "Ingrese 6-18 caracteres (letras y números)",
        accountPlaceholder: "Ingrese la cuenta del agente",
        domain: "Dominio del Agente",
        domainPlaceholder: "Ingrese dominio(s), separe múltiples dominios con comas",
        inviteCode: "Código de Invitación",
        inviteCodeTitle: "Código de Invitación del Agente",
        inviteCodeType: "Tipo de Código de Invitación",
        inviteCodeCustom: "Código de Invitación Personalizado",
        inviteCodeAuto: "Generado por Sistema",
        inviteCodeRequired: "Ingrese el código de invitación",
        inviteCodeRule: "El código de invitación debe tener 3-12 caracteres y contener letras y números",
        inviteCodePlaceholder: "Ingrese 3-12 caracteres (letras y números)",
        inviteCodeExist: "Este código de invitación ya existe, use otro",
        remark: "Comentario",
        add: "Añadir Agente",
        addSuccess: "Añadido exitosamente",
        edit: "Editar Agente",
        editSuccess: "Actualizado exitosamente",
        delete: "Eliminar",
        deleteSuccess: "Eliminado exitosamente",
        enabled: "Habilitado",
        enableSuccess: "Habilitado exitosamente",
        disabled: "Deshabilitado",
        disableSuccess: "Deshabilitado exitosamente",
        lastOpTime: "Última Hora de Operación",
        lastOpUser: "Último Operador",
        confirmDelete: "¿Está seguro de que desea eliminar este agente?",
        confirmEnable: "¿Está seguro de que desea habilitar este agente?",
        confirmDisable: "¿Está seguro de que desea deshabilitar este agente?",
        search: "Buscar",
        reset: "Restablecer",
        all: "Todos",
        action: "Acción",
        pagination: "Total {total} registros, Página {current} / {page}",
        domainFormatError: "Solo se aceptan dominios válidos sin 'http://' o 'https://'",
        accountFormatError: "La cuenta debe tener 6-18 caracteres y contener letras y números",
      disabledKyc: "Deshabilitar KYC de registro",
      confirmKycDisable: "Deshabilitar KYC de registro",
      optionFalse: "Operación fallida",
      confirmKycEnabled: "Habilitar KYC de registro",
      enabledKyc: "Habilitar KYC de registro",
      disabledWithdrawKyc: "Deshabilitar KYC de retiro",
      confirmWithdrawKycDisable: "Deshabilitar KYC de retiro",
      confirmWithdrawKycEnabled: "Habilitar KYC de retiro",
      enabledWithdrawKyc: "Habilitar KYC de retiro",
      agentLevel: "Nivel del Agente",
      agentLevelRequired: "Seleccione el nivel del agente",
      agentLevelTop: "Agente de Nivel Superior",
      agentLevelSub: "Agente de Subnivel",
      agentLevelTip: "Nivel Superior = agente padre; Subnivel = agente normal (requiere padre)",
      parentAgent: "Agente Padre",
      parentAgentRequired: "Seleccione un agente padre",
      parentAgentPlaceholder: "Seleccione un agente padre",
      parentAgentTip: "Requerido cuando se selecciona subnivel",
      agentLevelLockedTip: "El nivel del agente no se puede cambiar una vez establecido",
      parentAgentLockedTip: "El agente padre no se puede cambiar una vez establecido",
      expandSubAgents: "Expandir subagentes",
      collapseSubAgents: "Contraer subagentes",
      loginEnable: "Habilitado",
      confirmEnableLogin: "¿Habilitar inicio de sesión para este agente?",
      confirmEnableLoginContent: "Una vez habilitado, este agente podrá iniciar sesión normalmente.",
      confirmDisableLogin: "¿Deshabilitar inicio de sesión para este agente?",
      confirmDisableLoginContent: "Una vez deshabilitado, este agente no podrá iniciar sesión.",
      optionTrue: "Operación exitosa",
      loginPassword: "Contraseña de Inicio de Sesión",
      loginPasswordRequired: "Ingrese la contraseña de inicio de sesión",
      loginPasswordPlaceholder: "≥8 caracteres, letras + dígitos",
      loginPasswordRule: "La contraseña debe tener al menos 8 caracteres y contener letras y dígitos",
      loginPasswordTip: "Utilizada por el agente en el primer inicio de sesión",
      loginPasswordEditTip: "Deje en blanco para mantener la contraseña actual; de lo contrario debe tener ≥8 caracteres con letras y dígitos",
      confirmPassword: "Confirmar Contraseña",
      confirmPasswordRequired: "Reingrese la contraseña de inicio de sesión",
      confirmPasswordPlaceholder: "Reingrese la contraseña de inicio de sesión",
      confirmPasswordMismatch: "Las dos contraseñas no coinciden"
  },
  agentStats: {
    title: "Estadísticas del Agente",
    phpTab: "PHP",
    vndTab: "VND",
    agentType: "Tipo de Agente",
    agentTypePlaceholder: "Seleccione el tipo de agente",
    agentName: "Cuenta del Agente",
    agentNamePlaceholder: "Ingrese la cuenta del agente",
    currency: "Moneda",
    currencyPlaceholder: "Seleccione la moneda",
    sequence: "No.",
    loginUserCount: "Cantidad de Usuarios Conectados",
    registerCount: "Total de Miembros Registrados",
    totalRechargeAmount: "Monto Total de Depósitos",
    totalWithdrawalAmount: "Monto Total de Retiros",
    betFlow: "Apuestas Válidas",
    gameAmount: "P&L de Plataforma",
    cost: "Costo Total de Canal",
    registerCost: "Costo de Registro",
    firstRechargeCost: "Costo de Primer Depósito",
    costTooltip: "El valor total acumulado del \"costo\" de este agente",
    registerCostTooltip: "Costo de Registro = Costo Total de Canal / Total de Usuarios Registrados",
    firstRechargeCostTooltip: "Costo de Primer Depósito = Costo Total de Canal / Total de Usuarios con Primer Depósito",
    firstRechargeCount: "Cantidad de Primer Depósito",
    linkClickCount: "Cantidad de Clics de Enlace",
    activatedUserCount: "Usuarios Activados",
    activatedDepositUserCount: "Usuarios Activados con Depósito",
    currRegisterCost: "Costo de Registro Diario",
    currFirstRechargeCost: "Costo de Primer Depósito Diario",
    currRegisterCostTooltip: "Costo de Registro = Costo Diario / Usuarios Registrados Diarios",
    currFirstRechargeCostTooltip: "Costo de Primer Depósito = Costo Diario / Usuarios con Primer Depósito Diarios",
    pleaseSearchFirst: "Busque primero",
    riskCount: "Cantidad de Miembros en Riesgo",
    riskCountPercent: "Porcentaje de Miembros en Riesgo",
  },
  // Informe diario por categoría de juego (FBMPLAY-1670)
  agentGameCategoryReport: {
    gameCategory: "Categoría de Juego",
    gameProvider: "Proveedor de Juego",
    memberGroup: "Datos de Miembros",
    totalMemberCount: "Total de Miembros",
    registerCount: "Registrados Hoy",
    rechargeGroup: "Depósito",
    withdrawGroup: "Retiro",
    amountCol: "Monto",
    countCol: "Usuarios",
    betCount: "Apuestas",
    betAmount: "Apuesta",
    payoutAmount: "Pago",
    ggr: "GGR",
    totalGroup: "Total",
    totalBonus: "Bono Total",
    totalBet: "Apuesta Total",
    totalPayout: "Pago Total",
    totalGgr: "GGR Total",
    officialDirect: "Directo Oficial",
  },
  agentDailyStats: {
    title: "Desempeño Diario del Agente",
    day: "Fecha",
    agentType: "Tipo de Agente",
    agentName: "Cuenta del Agente",
    agentNamePlaceholder: "Ingrese la cuenta del agente",
    loginUserCount: "Cantidad de Usuarios Conectados",
    registerCount: "Cantidad de Registros",
    firstRechargeCount: "Cantidad de Primer Depósito",
    firstDepositAmount: "Monto del Primer Depósito",
    rechargeCount: "Cantidad de Depósitos",
    rechargeAmount: "Monto de Depósitos",
    linkClickCount: "Cantidad de Clics de Enlace",
    activatedUserCount: "Usuarios Activados",
    activatedDepositUserCount: "Usuarios Activados con Depósito",
    withdrawalCount: "Cantidad de Retiros",
    withdrawalAmount: "Monto de Retiros",
    betFlow: "Apuestas Válidas",
    gameAmount: "P&L de Plataforma",
    betAmount: "Monto de Apuestas",
    payoutAmount: "Monto de Pago",
    ggr: "GGR",
    netAmount: "P&L de Depósito/Retiro",
    pleaseSearchFirst: "Busque primero"
  },
  agentCostStats: {
    title: "Costo de Promoción",
    day: "Fecha",
    agentType: "Tipo de Agente",
    agentName: "Cuenta del Agente",
    agentNamePlaceholder: "Ingrese el nombre del agente",
    registerCount: "Cantidad de Registros",
    rechargeCount: "Cantidad de Depósitos",
    rechargeAmount: "Monto de Depósitos",
    withdrawalCount: "Cantidad de Retiros",
    withdrawalAmount: "Monto de Retiros",
    profit: "Ganancia/Pérdida",
    cost: "Costo",
    returnRate: "Tasa de Retorno de Costo",
    paybackDays: "Días de Recuperación",
    action: "Acción",
    editCost: "Costo",
    editCostModalTitle: "Editar Costo",
    costLabel: "Monto de Costo",
    costPlaceholder: "Ingrese el monto del costo",
    costRequired: "Ingrese el monto del costo",
    costMinValue: "El monto del costo no puede ser menor que 0",
    updateCostSuccess: "Costo actualizado exitosamente",
    pleaseSearchFirst: "Busque primero",
    dateRangeExceeds31Days: "El rango de fechas no puede exceder 31 días"
  },
  agentTodayData: {
    title: "Datos del Agente de Hoy",
    levelTop: "Superior",
    levelSub: "Sub",
    levelSelf: "Directo",
    aggregatedSuffix: "(Total)",
    agentAccount: 'Cuenta del Agente',
    search: 'Buscar',
    pleaseEnterAgentAccount: 'Ingrese la cuenta del agente',
    agentAccountNotFound: 'La cuenta del agente que ingresó no existe, reingrese',
    noData: 'Sin datos, busque un agente primero',
    registerCount: 'Usuarios Registrados',
    firstRechargeCount: 'Usuarios con Primer Depósito',
    rechargeCount: 'Usuarios con Depósito',
    withdrawalCount: 'Usuarios con Retiro',
    profit: 'P&L de Depósito/Retiro',
    firstRechargeAmount: 'Monto del Primer Depósito',
    rechargeAmount: 'Monto de Depósitos',
    withdrawalAmount: 'Monto de Retiros',
    agentAccountDigitsOnly: 'La cuenta del agente solo puede contener dígitos',
  },
  agentTag: {
    title: "Etiqueta del Agente",
    serial: "No.",
    tagName: "Nombre de Etiqueta",
    tagNameRequired: "Ingrese el nombre de la etiqueta",
    tagNamePlaceholder: "Ingrese",
    remark: "Comentario",
    remarkPlaceholder: "Ingrese",
    lastOpTime: "Última Hora de Operación",
    lastOpUser: "Último Operador",
    action: "Acción",
    add: "Añadir Etiqueta de Agente",
    addSuccess: "Añadido exitosamente",
    edit: "Editar",
    editSuccess: "Actualizado exitosamente",
    delete: "Eliminar",
    deleteSuccess: "Eliminado exitosamente",
    confirmDelete: "¿Está seguro de que desea eliminar esta etiqueta?",
    search: "Buscar",
    reset: "Restablecer",
    pagination: "Total {total} registros, Página {current} / {page}",
  },
  agentTransfer: {
    // Top tabs
    tab_transfer: "Transferencia de Agente",
    tab_history: "Registros de Transferencia",
    tab_game_category: "Informe Diario por Categoría de Juego",
    // Sidebar (AgentTreeSidebar)
    sidebar_search_placeholder: "Buscar cuenta del agente",
    sidebar_empty: "Sin agentes",
    sidebar_tag_l1: "L1",
    sidebar_tag_l2: "L2",
    sidebar_subagent_count_tooltip: "{count} subagentes",
    sidebar_loading: "Cargando…",
    sidebar_no_subagents: "Sin subagentes",
    // Empty states
    empty_select_l1: "Seleccione un agente de nivel superior (L1) desde la izquierda",
    empty_select_l2: "Seleccione un agente de subnivel (L2) desde la izquierda",
    // L1 panel (AgentTransferTab)
    tag_top_agent: "Agente de Nivel Superior",
    tag_sub_agent: "Agente de Subnivel",
    stat_sub_count: "Subagentes",
    stat_direct_member: "Miembros directos",
    btn_demote_to_l2: "Degradar a L2",
    card_subagent_list: "Subagentes",
    col_agent_account: "Cuenta del Agente",
    col_agent_name: "Nombre del Agente",
    col_action: "Acción",
    btn_transfer: "Transferir",
    empty_no_subagent_for_l1: "Este agente L1 no tiene subagentes",
    member_count_unit_suffix: "",
    card_direct_member: "Miembros directos",
    card_recent_log: "Registros de transferencia recientes",
    btn_view_all_log: "Ver todos los registros",
    no_recent_log: "Sin registros",
    log_upgrade_text: "{account} ascendido de L2 a L1",
    log_demote_text: "{account} degradado de L1 a L2, asignado a {target}",
    log_transfer_text: "{account} movido de {from} → {to}",
    // Demote blocker
    demote_blocked_title: "No se puede degradar directamente",
    demote_blocked_line1: "Este agente L1 aún tiene {count} subagentes y no se puede degradar directamente.",
    demote_blocked_line2: "Transfiera primero los subagentes a otro agente L1 y luego realice la degradación.",
    // SubAgentDetailPanel
    sub_panel_parent_l1: "L1 Padre: ",
    sub_panel_member_count: "Miembros directos",
    btn_transfer_to_other_l1: "Transferir a otro L1",
    btn_upgrade_to_l1: "Ascender a L1",
    // AgentMemberListCard
    member_card_title_default: "Miembros directos",
    member_col_account: "Cuenta del Miembro",
    member_col_vip: "Nivel VIP",
    member_col_deposit: "Depósito Total",
    member_col_last_login: "Último Inicio de Sesión",
    member_col_status: "Estado",
    member_status_active: "Activo",
    member_status_inactive: "Inactivo",
    member_empty: "Este agente no tiene miembros directos",
    member_total: "{total} filas",
    member_load_fail: "Error al cargar la lista de miembros",
    // TransferSubAgentModal
    transfer_modal_title: "Transferir Subagente",
    transfer_modal_ok: "Confirmar Transferencia",
    modal_cancel: "Cancelar",
    modal_label_account: "Cuenta del Agente: ",
    modal_label_name: "Nombre del Agente: ",
    modal_label_current_parent: "Padre Actual: ",
    modal_label_member_count: "Miembros Directos: ",
    transfer_info_member_count: "Miembros directos",
    transfer_info_follow: "Todos seguirán la transferencia al L1 destino",
    transfer_field_target: "Agente L1 Destino",
    transfer_field_target_required: "Seleccione el agente L1 destino",
    transfer_field_target_placeholder: "Seleccione el agente L1 destino",
    transfer_field_reason: "Razón de Transferencia",
    transfer_field_reason_required: "Ingrese la razón de transferencia",
    transfer_field_reason_placeholder: "Ingrese la razón de transferencia",
    transfer_impact_title: "Impacto después de la transferencia:",
    transfer_impact_1: "1. Este subagente se mueve bajo el L1 destino; sus miembros directos permanecen asignados a este subagente.",
    transfer_impact_2_a: "2. Los agentes directos de los miembros no cambian — solo el L1 ascendente cambia de \"",
    transfer_impact_2_b: "\" al L1 destino.",
    transfer_impact_3: "3. Los registros históricos de apuestas / depósito / retiro mantienen su atribución original y no se actualizarán retroactivamente.",
    transfer_impact_4: "4. Los nuevos datos generados después de la transferencia se contarán bajo la nueva atribución.",
    transfer_impact_5: "5. Los datos de resumen (registros, depósitos, retiros, apuestas válidas, P&L) para L1 original y destino se recalcularán.",
    transfer_alert: "Todos los miembros directos seguirán la transferencia · Ningún miembro quedará huérfano o duplicado · Esta acción no se puede deshacer",
    // UpgradeSubAgentModal
    upgrade_modal_title: "Ascender a Agente L1",
    upgrade_modal_ok: "Confirmar Ascenso",
    upgrade_current: "Actual: ",
    upgrade_info_follow: "Todos seguirán como miembros directos bajo el nuevo L1",
    upgrade_impact_title: "Impacto después del ascenso:",
    upgrade_impact_1: "1. El nivel de este agente cambia de L2 a L1, dejando la gestión del L1 original y convirtiéndose en L1 independiente.",
    upgrade_impact_2_bold: "Todos los miembros directos seguirán",
    upgrade_impact_2_post: ", cambiando de \"miembros directos de L2\" a \"miembros directos de nuevo L1\".",
    upgrade_impact_3: "3. El agente padre de los miembros no cambia (sigue siendo el mismo agente); solo se eleva el nivel del agente.",
    upgrade_impact_4: "4. El código de invitación permanece sin cambios; nuevo privilegio obtenido: configuración de dominio del agente.",
    upgrade_impact_5: "5. Los datos de resumen (registros, depósitos, retiros, apuestas válidas, P&L) para el L1 original se recalcularán completamente.",
    upgrade_impact_note: "Sin conflictos: el agente padre del miembro no cambia — solo se asciende el nivel del agente.",
    upgrade_field_reason: "Razón del Ascenso",
    upgrade_field_reason_required: "Ingrese la razón del ascenso",
    upgrade_field_reason_placeholder: "p. ej. expansión de negocios, operación independiente, etc.",
    upgrade_success_alert_prefix: "✅ Se convierte en agente L1 independiente · Todos los miembros directos siguen · Código de invitación conservado · Configuración de dominio del agente disponible · ",
    upgrade_success_alert_bold: "Esta acción no se puede deshacer",
    // DemoteTopAgentModal
    demote_modal_title: "Degradar a Agente L2",
    demote_modal_ok: "Confirmar Degradación",
    demote_label_current: "Agente Actual: ",
    demote_label_current_tier: "Nivel Actual: ",
    demote_label_after_tier: "Después de Degradación: ",
    demote_field_new_parent: "Nuevo Agente L1 Padre",
    demote_field_new_parent_required: "Seleccione el nuevo agente L1 padre",
    demote_field_new_parent_placeholder: "Seleccione a qué agente L1 asignar después de la degradación",
    demote_field_reason: "Razón de Degradación",
    demote_field_reason_required: "Ingrese la razón de degradación",
    demote_field_reason_placeholder: "Ingrese la razón de degradación",
    demote_impact_title: "Impacto después de la degradación:",
    demote_impact_1: "1. El nivel del agente cambia de \"L1\" a \"L2\", asignado bajo el agente L1 destino.",
    demote_impact_2: "2. Los miembros directos existentes del agente mantienen su atribución (seguimiento automático).",
    demote_impact_3: "3. El código de invitación y dominio del agente permanecen sin cambios; los nuevos miembros aún pueden registrarse a través del canal original.",
    demote_impact_4: "4. Los registros históricos de apuestas / depósito / retiro mantienen su atribución original y no se actualizarán retroactivamente.",
    demote_alert: "Esta acción no se puede deshacer · Después de la degradación, el agente ya no aceptará nuevos agentes L2 como L1 · Para restaurar, contacte al administrador.",
    // Page-level messages
    msg_load_agent_list_fail: "Error al cargar la lista de agentes",
    msg_load_subagent_fail: "Error al cargar la lista de subagentes",
    msg_transfer_success: "{account} ha sido transferido a {target}",
    msg_transfer_fail: "Transferencia fallida",
    msg_upgrade_success: "{account} ha sido ascendido a un agente L1",
    msg_upgrade_fail: "Ascenso fallido",
    msg_demote_success: "{account} ha sido degradado y asignado a {target}",
    msg_demote_fail: "Degradación fallida",
  },
  transferLog: {
    related_top_agent: "Agente L1 Relacionado",
    related_top_agent_hint: "(Solo mostrando registros de transferencia / degradación / ascenso relacionados con este agente L1)",
    filter_transfer_type: "Tipo de Operación",
    filter_transfer_type_placeholder: "Todos",
    filter_agent_account: "Cuenta del Agente",
    filter_agent_account_placeholder: "Agente destino",
    filter_from_parent: "Desde L1",
    filter_from_parent_placeholder: "Cuenta L1 original",
    filter_to_parent: "Hacia L1",
    filter_to_parent_placeholder: "Cuenta L1 nueva",
    filter_date_range: "Hora de Operación",
    search: "Buscar",
    reset: "Restablecer",
    query_fail: "Consulta fallida",
    type_transfer: "Transferir",
    type_demote: "Degradar",
    type_upgrade: "Ascender",
    col_record_id: "ID de Registro",
    col_transfer_type: "Operación",
    col_agent_account: "Cuenta del Agente",
    col_from: "Desde",
    col_to: "Hacia",
    col_reason: "Razón",
    col_operator: "Operador",
    col_create_time: "Hora de Operación",
    tier_l1: "L1",
    tier_l2: "L2",
    total: "{total} filas",
  },
  agentType: {
    title: "Tipo de Agente",
    serial: "No.",
    typeName: "Nombre de Tipo",
    typeNameRequired: "Ingrese el nombre del tipo",
    typeNamePlaceholder: "Ingrese",
    typeDesc: "Descripción del Tipo",
    typeDescRequired: "Ingrese la descripción del tipo",
    typeDescPlaceholder: "Ingrese",
    lastOpTime: "Última Hora de Operación",
    lastOpUser: "Último Operador",
    action: "Acción",
    add: "Añadir",
    addSuccess: "Añadido exitosamente",
    edit: "Editar",
    editSuccess: "Actualizado exitosamente",
    delete: "Eliminar",
    deleteSuccess: "Eliminado exitosamente",
    confirmDelete: "¿Está seguro de que desea eliminar este tipo?",
    search: "Buscar",
    reset: "Restablecer",
    pagination: "Total {total} registros, Página {current} / {page}",
  }
};
